import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import BlogCategories from "@jsons/blogCategories.json"
import BlogPosts from "@jsons/blogPosts.json"
import NewsArchivejson from "@jsons/newsArchive.json"
import BlogListSection from "@pages/Blog/BlogListSection"
import React from "react"

type Props = {}

const NewsArchive = (props: Props) => {
	const pageData = getTranslatedPageData(NewsArchivejson, true, true)
	const AdvancedSideAsset = getValueOrThrow(pageData.AdvancedSideAsset)

	const translatedCategories = getPosts("CategoriesModule", {
		data: BlogCategories,
	})

	const Posts = getPosts("BlogPostsModule", {data: BlogPosts})

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath="/inspiration/news-archive"
			/>

			<FullWidthHeader
				data={getValueOrThrow(AdvancedSideAsset[0].mainContent)[0]}
				position={"left"}
				size={"L"}
			/>
			<BlogListSection categories={translatedCategories} data={Posts} />
		</>
	)
}

export default NewsArchive
